export default __webpack_public_path__ + "static/media/finalPrizeBingo.9a3a354f.png";